'use strict';

angular.module('mean.general-tasks').controller('BuilderAdminTasksController', ['$scope', 'Global', 'Menus', '$rootScope', '$http', 'GeneralTasks', '$filter', 'tradeCodeService',
    function($scope, Global, Menus, $rootScope, $http, GeneralTasks, $filter, tradeCodeService) {
        $scope.global = Global;
        $scope.tasks = [];
        $scope.all_tasks = [];

        $scope.hasAuthorization = function(task) {
          if (!task || !task.user) return false;
          return $scope.global.isAdmin || task.user._id === $scope.global.user._id;
        };

        $scope.init = function() {
            GeneralTasks.query({}, function(tasks) {
                $scope.all_tasks = $scope.tasks = $filter('orderBy')(tasks, 'order');
            });
        };

        $scope.onSelect = function() {
          if($scope.selectedItem) {
            $scope.tasks = $filter('filter')($scope.tasks, { trade: $scope.selectedItem });
          } else {
            $scope.tasks = $scope.all_tasks;
          }
        };

        $scope.getTradeName = function(id) {
            return tradeCodeService.getName(id);
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/builderAdminTasks.js